import styled from 'styled-components';

import wave from '../../../static/onboarding/wave.svg';
import waveMask from '../../../static/onboarding/wave-mask.svg';

const waveUrl = `url("${wave}")`;

const waveMaskUrl = `url("${waveMask}")`;

const imageHeight = 60;

export const Wrapper = styled.div`
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  scroll-snap-align: start;
  padding-bottom: var(--gap);

  @media (screen-spanning: single-fold-vertical) {
    width: env(fold-left);
  }

  @media (horizontal-viewport-segments: 2) {
    width: env(viewport-segment-right 0 0);
  }
`;

export const ImageContainer = styled.div`
  flex: 1;
  width: 100%;
  overflow: hidden;
`;

const shouldForwardProp = () => true;

export const Image = styled('img').withConfig({ shouldForwardProp })`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Wave = styled.div<{ current: number; total: number }>`
  width: 100%;
  height: ${imageHeight}px;
  margin-top: -${imageHeight / 2 + 10}px;
  background-image: ${waveUrl};
  background-size: ${(props) => props.total * 100}% 100%;
  background-position: ${(props) => props.current * -100}% 0;
  z-index: 1;
`;

export const WaveMask = styled.div<{ backgroundColor: string; current: number; total: number }>`
  width: 100%;
  height: ${imageHeight}px;
  margin-top: -${imageHeight}px;
  margin-bottom: -${imageHeight / 2 - 20}px;
  background: ${(props) => props.backgroundColor};
  transition: background-color ease-in-out 200ms;
  mask-image: ${waveMaskUrl};
  mask-size: ${(props) => props.total * 100}% 100%;
  mask-position: ${(props) => props.current * -100}% 0;
`;

export const Text = styled.p`
  margin: var(--gap);
  margin-bottom: 0;
  font: inherit;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
`;
